import { IAction } from "../../../redux/actions";
import { IDialogMessageFragment } from "./Dialogs";

export interface IDialogOptions {
  title: string;
  message?: string | IDialogMessageFragment[];
  centerMessage?: boolean;
  cover?: boolean;
  buttons: {
    primary?: boolean;
    label: string;
    callback: () => void;
  }[];
}

export interface IShowDialog {
  options: IDialogOptions;
}

export interface IDialogAction extends Partial<IDialogOptions> {
  type: types.SHOW_DIALOG | types.HIDE_DIALOG;
}

export interface IShowDialogAction extends IDialogOptions, IAction {}

export enum types {
  SHOW_DIALOG = "SHOW_DIALOG",
  HIDE_DIALOG = "HIDE_DIALOG"
}

export const showDialog = ({
  title,
  message,
  buttons,
  cover,
  centerMessage
}: IDialogOptions): IShowDialogAction => {
  return {
    type: types.SHOW_DIALOG,
    title,
    message,
    buttons,
    cover,
    centerMessage
  };
};

export const hideDialog = (): IAction => {
  return {
    type: types.HIDE_DIALOG
  };
};
